export class User {
	id: Number;
	login: String;
	senha: String;
	nome: String;
	cpf: String;
	dataNascimento: String;
	salario: DoubleRange;
}
